import { Form } from 'react-bootstrap';
import GrupperingPicker from 'components/GrupperingPicker';
import { IEnhetsgruppeNode } from 'components/GrupperingPicker/types';
import Style from '../index.module.css';
import { FlyttEnheterTilEnhetsgruppeCommand } from 'services/KjederegisteretAdminApi/EnheterBulkApi/types';
import { NorwegianDatepicker } from 'components/NorwegianDatepicker';

interface Props {
  command: FlyttEnheterTilEnhetsgruppeCommand;
  onCommandUpdated: (
    updater: (prev: FlyttEnheterTilEnhetsgruppeCommand) => FlyttEnheterTilEnhetsgruppeCommand,
  ) => void;
}

const FlyttEnheterTilEnhetsgruppeForm = (props: Props) => {
  const handleFraOgMedChanged = (fraOgMed: Date) => {
    props.onCommandUpdated((prev) => ({
      ...prev,
      fraOgMed,
    }));
  };

  const handleFraGrupperingSelected = (nodes: IEnhetsgruppeNode[]) => {
    console.log('FraSelected');
    console.log(nodes);
    if (nodes.length > 0) {
      props.onCommandUpdated((prev) => ({
        ...prev,
        fraEnhetsgruppeNummer: nodes[0].nr,
      }));
    }
  };

  const handleTilGrupperingSelected = (nodes: IEnhetsgruppeNode[]) => {
    console.log('TilSelected');
    if (nodes.length > 0) {
      props.onCommandUpdated((prev) => ({
        ...prev,
        tilEnhetsgruppeNummer: nodes[0].nr,
      }));
    }
  };

  const toggleOverforKundenummer = (overforKundenummer: boolean) => {
    props.onCommandUpdated((prev) => ({
      ...prev,
      overforKundenummer,
    }));
  };

  return (
    <>
      <Form.Group className={Style.formGroup}>
        <Form.Label>Fra og med dato</Form.Label>
        <NorwegianDatepicker
          value={props.command.fraOgMed}
          onChange={(value) => handleFraOgMedChanged(value)}
          showFirstDaySuggestions
        />
      </Form.Group>
      <Form.Group className={Style.formGroup}>
        <Form.Label className={Style.secondLabel}>Fra enhetsgruppering</Form.Label>
        <GrupperingPicker
          treeSelectMode="radioSelect"
          closeOnSelect={true}
          onSelectionChanged={handleFraGrupperingSelected}
        />
      </Form.Group>
      <Form.Group className={Style.formGroup}>
        <Form.Label className={Style.secondLabel}>Til enhetsgruppering</Form.Label>
        <GrupperingPicker
          treeSelectMode="radioSelect"
          closeOnSelect={true}
          onSelectionChanged={handleTilGrupperingSelected}
        />
        <div className={Style.checkbox}>
          <Form.Check
            checked={props.command.overforKundenummer}
            onChange={() => toggleOverforKundenummer(!props.command.overforKundenummer)}
          />
          <Form.Label>Overfør kundenummere?</Form.Label>
        </div>
      </Form.Group>
    </>
  );
};

export default FlyttEnheterTilEnhetsgruppeForm;
